/**
 * Faz upload de um arquivo para uma URL assinada (ex.: Supabase).
 * Usa fetch diretamente pois a URL é externa ao backend da aplicação.
 */
export async function uploadFileToSignedUrl(
  signedUploadUrl: string,
  token: string,
  file: File
): Promise<void> {
  const response = await fetch(signedUploadUrl, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': file.type || 'application/octet-stream',
    },
    body: file,
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `Upload falhou: ${response.status}`);
  }
}
